
import _ from "lodash";


export default {

    setFilters(state, filters){
        state.filters = filters;
    },

    setCursor(state, cursor){
        state.cursor = cursor;
    },

    setSelectedFilters(state, setSelectedFilters){
        state.setSelectedFilters = setSelectedFilters;
    },

    setSelectedFilter(state, filter) {
        _.map(filter, (value, field) => {
            state.selectedFilters[field] = value;
        })
    },

    setReport(state, report) {
        state.report = report;
    },

    setDailyReport(state, report) {
        state.dailyReport = report;
    },

    setSelectedColumns(state, selectedColumns) {
        state.selectedColumns = selectedColumns;
    },

    setFixedColumns(state, fixedColumns) {
        state.fixedColumns = fixedColumns;
    },

    setSortedColumns(state, sortedColumns) {
        state.sortedColumns = sortedColumns;
    },

    setLimit(state, limit) {
        state.limit = limit;
    },

    setDirection(state, direction) {
        state.direction = direction;
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/adgroupReport2/mutations.js